import {Component, OnInit, EventEmitter, Input, Output} from '@angular/core'
import {loadDirection} from '../terminal-events-list/terminal-events-list.component'
import {jumpType} from '../../enums/jump-type.enum'

@Component({
  selector: 'app-terminal-events-jumper',
  templateUrl: './terminal-events-jumper.component.html',
  styleUrls: ['./terminal-events-jumper.component.scss'],
  standalone: false,
})
export class TerminalEventsJumperComponent implements OnInit {
  @Input() config: {
    showAnyJumper: boolean
    showTypeJumper?: boolean
    showBootJumper: boolean
    showLabels: boolean
    extraSmall: boolean
  } | null = null
  @Output() clicked = new EventEmitter<{type: string; direction: string}>()

  html = `<span class="d-block w-100 btn-danger well-sm">Never trust not sanitized HTML!!!</span>`

  constructor() {}

  ngOnInit() {}

  next(event) {
    event.stopPropagation()
    this.clicked.emit({
      type: jumpType.ANY_TYPE,
      direction: loadDirection.TIME_FORWARD,
    })
  }

  previous(event) {
    event.stopPropagation()
    this.clicked.emit({
      type: jumpType.ANY_TYPE,
      direction: loadDirection.TIME_BACKWARD,
    })
  }

  nextBoot(event) {
    event.stopPropagation()
    this.clicked.emit({
      type: jumpType.BOOT,
      direction: loadDirection.TIME_FORWARD,
    })
  }

  previousBoot(event) {
    event.stopPropagation()
    this.clicked.emit({
      type: jumpType.BOOT,
      direction: loadDirection.TIME_BACKWARD,
    })
  }

  nextOfType(event) {
    event.stopPropagation()
    this.clicked.emit({
      type: jumpType.SAME_TYPE,
      direction: loadDirection.TIME_FORWARD,
    })
  }

  previousOfType(event) {
    event.stopPropagation()
    this.clicked.emit({
      type: jumpType.SAME_TYPE,
      direction: loadDirection.TIME_BACKWARD,
    })
  }
}
